/*************************************************/
/* JOB APPLICATION                               */
/*************************************************/

export function jobApplication() {
    const formSelector = '.job-detail__form';
    const statusSelector = '.job-detail__status';
    const submitSelector = '.job-detail__submit';
    const statusErrorClass = 'job-detail__status--error';
    const statusSuccessClass = 'job-detail__status--success';

    const setStatus = (status, message, isError) => {
        if (!status) return;

        status.textContent = message;
        status.classList.toggle(statusErrorClass, isError);
        status.classList.toggle(statusSuccessClass, !isError);
    };

    const init = () => {
        document.querySelectorAll(formSelector).forEach(form => {
            const status = form.querySelector(statusSelector);
            const submit = form.querySelector(submitSelector);

            form.addEventListener('submit', async event => {
                event.preventDefault();

                if (!form.reportValidity()) return;

                if (submit) submit.disabled = true;
                setStatus(status, '', false);

                try {
                    const response = await fetch(form.action, {
                        method: 'POST',
                        body: new FormData(form),
                        headers: { 'Accept': 'application/json' },
                    });

                    if (!response.ok) throw new Error(response.status);

                    setStatus(status, form.dataset.successMessage, false);
                    form.reset();
                } catch {
                    setStatus(status, form.dataset.errorMessage, true);
                } finally {
                    if (submit) submit.disabled = false;
                }
            });
        });
    };

    init();
}
